export enum LearningJourneyView {
    Map = 'Map',
    List = 'List'
}